import { useState, useMemo } from 'react'
import { Modal, Checkbox, Button, SelectPicker, CheckPicker } from 'rsuite'
import './scss/cards.scss'
import CurrencyInput from 'react-currency-input-field';
import { optionsTimeCard, optionsHourLast, optionsMinus, optionWaxing } from './constant/TimeUsingCard'
import Select from "react-select";
import { notifications } from "../constant/Notify";
let _ = require('lodash');

const cardTypes = [
	{
		type: 1,
		text: "Thẻ số lần"
	},
	{
		type: 2,
		text: "Thẻ số tiền",
	}
]

const ModalCreateCard = ({ open, setOpen, addPackage, products, listSelectGroup }) => {
	const [cardType, setCardType] = useState(1)
	const [productName, setProductName] = useState('')
	const [price, setPrice] = useState(0)
	const [basePrice, setBasePrice] = useState(null)
	const [categoryId, setCategoryId] = useState(null)
	const [description, setDescription] = useState('')
	const [status, setStatus] = useState(1)
	const [maxUsed, setMaxUsed] = useState('0')
	const [createCardType, setCreateCardType] = useState('1')
	const [comServe, setComServe] = useState(0)
	const [comConsult, setComConsult] = useState(0)
	const [useTimeMonth, setUseTimeMonth] = useState('127')
	const [cardAccount, setCardAccount] = useState('')
	const [productNameE, setProductNameE] = useState('')
	const [rangeDate, setRangeDate] = useState(0)
	const [timeUsing, setTimeUsing] = useState(optionsTimeCard[6] )
	const [productId, setProductId] = useState(null)
	const [upgradeId, setUpgradeId] = useState(null)
	const [productUsingIds, setProductUsingIds] = useState([])
	const [defaultValueUpgrade, setDefaultValueUpgrade] = useState(null)
	const [defaultProductUsingId, setDefaultProductUsingId] = useState(null)
	const [countVoucherUse, setCountVoucherUse] = useState(null)
	const [typeUsing, setTypeUsing] = useState(false)
	const [typeSell, setTypeSell] = useState(true)
	const [specialService, setSpecialService] = useState(false)
	const [maxUseChild, setMaxUseChild] = useState(false)
	const [warranty, setWarranty] = useState(0)
	const [rangeWarranty, setRangeWarranty] = useState(0)
	const [lastHour, setLastHour] = useState(optionsHourLast[12])
	const [lastMinus, setLastMinus] = useState(optionsMinus[0])
	const [giftPackageId, setGiftPackageId] = useState("")
	const [newWaxing, setNewWaxing] = useState(optionWaxing[0].value)
	const [warrantyExpiry, setWarrantyExpiry] = useState(0)
	const [numberFamily, setNumberFamily] = useState(0)

	let onChangePrice = (event) => {
		let dataPrice = event?.target?.value.replaceAll(",", "") ?? 0
		setPrice(dataPrice)
	};

	let onChangeBasePrice = (event) => {
		let dataBasePrice = event?.target?.value.replaceAll(",", "") ?? 0;
		setBasePrice(dataBasePrice)
	};

	const onSelectCategory = (event) => {
		setCategoryId(event.value)
		if (event.value == 5) {
			setNewWaxing(optionWaxing[2].value)
		} else {
			setNewWaxing(optionWaxing[0].value)
		}
	}

	const onSelectUpgrade = (e) => {
		let value = _.map(e, "value")
		setUpgradeId(value)
	}
	const onSelectProductUsingIds = (e) => {
		let value = _.map(e, "value")
		if (!value || value.length === 0) {
			setTypeUsing(false)
			setMaxUseChild(false)
		}
		setProductUsingIds(value)
	}

	const onSelectGiftPackage = (e) => {
		let value = _.map(e, "value")
		setGiftPackageId(value)
	}

	const addNewPackage = () => {		
		let rawMeta = {
			"max_used": maxUsed,
			"card_type": createCardType,
			"use_time_month": useTimeMonth,
			"card_account": cardAccount,
			"time_using": timeUsing?.value ?? null,
			"product_id": productId?.value ?? null,
			"last_hour": lastHour?.value ?? null,
			"last_minute": lastMinus?.value ?? null,
			"upgrade_id": upgradeId,
			"gift_package": giftPackageId,
			"product_using_ids": productUsingIds,
			"warranty": warranty,
			"range_warranty": rangeWarranty,
			"warranty_expiry": warrantyExpiry
		}
		const meta_object = Object.keys(rawMeta).reduce((acc, key) => {
			const value = rawMeta[key];
			if (value !== undefined && value !== null && value !== "") {
				acc[key] = value;
			}
			return acc;
		}, {});

		const dataServices = {
			"product_name": productName,
			"price": price,
			"base_price": basePrice,
			"category_id": categoryId,
			"description": description,
			"status": status,
			"type": 2,
			"range_date": rangeDate,
			"product_name_e": productNameE,
			"count_voucher_use": countVoucherUse,
			"type_using": typeUsing ? 1 : 0,
			"open_sell": (typeSell) ? 0 : 1,
			"special_service": (specialService) ? 1 : 0,
			"max_use_child": (maxUseChild) ? 1 : 0,
			"com": comServe,
			"new_waxing": newWaxing.value ?? 0,
			"number_family": numberFamily,
			"meta_object": meta_object
		}


		if (!productName || maxUsed == 0) {
			notifications({
				type: "error",
				mess: "Vui lòng điển đủ thông tin vào ô tô đậm",
			});
			return
		}
		addPackage(dataServices)
	}

	if (open) {
		return (
			<div className="popup-cent action-package">
				<div className="content-popup fadeInDown">
					<div className="head-popup">
						<div className="title">Tạo thẻ dịch vụ</div>
						<div className="close" onClick={() => setOpen(!open)}>×</div>
					</div>
					<div className="body-popup">
						<form>
							<div className="form-card-wrapper">
								<div className="flex justify-between">
									<label htmlFor="productName" className="control-label left col-3">Tên thẻ</label>
									<input id="productName" onChange={(e) => {setProductName(e.target.value)}} className="form-control required input-xs ng-pristine ng-untouched ng-valid ng-empty" placeholder="Tên thẻ" />
								</div>
								{/* <div className="flex mt-10 justify-between">
									<label htmlFor="productNameE" className="control-label col-3">Tên tiếng anh</label>
									<input id="productNameE" onChange={(e) => {setProductNameE(e.target.value)}} className="form-control input-xs ng-pristine ng-untouched ng-valid ng-empty" placeholder="Nhập thẻ tên tiếng anh" />
								</div>
								<div className="flex mt-10 justify-between">
									<label htmlFor="description" className="control-label col-3">Mô tả chức năng thẻ</label>
									<textarea id="description" onChange={(e) => {setDescription(e.target.value)}} className="form-control input-xs ng-pristine ng-untouched ng-valid ng-empty" placeholder="Mô tả chức năng thẻ" />
								</div> */}
								<div className="flex mt-10">
									<label htmlFor="price" className="control-label left col-3">Giá bán thẻ</label>
									<div className="flex group-price">
										<CurrencyInput
											htmlFor="price"
											className="form-control price-input required"
											placeholder="Nhập giá thẻ"
											defaultValue={0}
											groupSeparator={','}
											decimalSeparator={'.'}
											onChange={(e) => {onChangePrice(e)}}
										/>
										<div className="currency">₫</div>
									</div>
								</div>
								{cardType == 1 ?
									<div className="flex mt-10">
										<label className="control-label left col-3">Thông tin sử dụng</label>
										<div className="row w-100">
											<div className="col-xs-12 col-md-6">
												<label className="control-label">Số buổi sử dụng</label>
												<input id="maxUsed" onChange={(e) => {setMaxUsed(e.target.value)}} className="form-control price-input w-100 required" value={maxUsed} />
											</div>
											<div className="col-xs-12 col-md-6">
												<label className="control-label">Số người sở hữu</label>
												<input type="number"  onChange={(e) => setNumberFamily(Number(e.target.value))} className="form-control w-100 price-input" defaultValue={numberFamily} />
											</div>
										</div>
									</div>
								:
									<div className="flex mt-10 justify-between">
										<label htmlFor="cardAccount"  className="control-label left col-3">Số tiền trong thẻ</label>
										<div className="flex w-100">
											<input id="cardAccount" onChange={(e) => {setCardAccount(e.target.value)}} className="price-input required ng-pristine ng-untouched ng-valid ng-empty" />
										</div>
									</div>
								}

								<div className="flex mt-10">
									<label htmlFor="useTimeMonth" className="control-label left col-3">Thời hạn thẻ</label>
									<div className="flex gap-20 item-flex-start w-100">
										<input id="useTimeMonth" onChange={(e) => {setUseTimeMonth(e.target.value)}} className="form-control w-20 price-input" defaultValue={127} placeholder="127" />
										<span className="input-group-addon">(Đơn vị: Tháng)</span>
									</div>
								</div>
								{cardType == 1 ?
									<div className="flex mt-10">
										<label className="control-label left col-3">Thời gian làm dịch vụ</label>
										<div className="row gap-20 item-flex-start w-100">
											<div className="col-6">
												{optionsTimeCard.length > 0 ?
													<Select components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }} 
														className="basic-single w-100"
														classNamePrefix="select"
														closeMenuOnSelect={true}
														isClearable={true}
														isSearchable={true}
														defaultValue={timeUsing}
														onChange={setTimeUsing}
														options={optionsTimeCard}
													/>
												:null}
											</div>
										</div>
									</div>
								: null}
								<div className="flex mt-10">
									<label htmlFor="lastHour" className="control-label left col-3">Thời gian đặt lịch muộn nhất</label>
									<div className=" gap-20 item-flex-start w-100">
										<div className="row">
											<div className="col-6">
												{optionsHourLast.length > 0 ?
													<Select components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }} 
														className="basic-single w-100"
														classNamePrefix="select"
														closeMenuOnSelect={true}
														isClearable={true}
														isSearchable={true}
														defaultValue={lastHour}
														onChange={setLastHour}
														options={optionsHourLast}
													/>
												:null}
											</div>
											<div className="col-6">
												{optionsMinus.length > 0 ?
													<Select components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }} 
														className="basic-single w-100"
														classNamePrefix="select"
														closeMenuOnSelect={true}
														isClearable={true}
														isSearchable={true}
														defaultValue={lastMinus}
														onChange={setLastMinus}
														options={optionsMinus}
													/>
												:null}
											</div>
										</div>
									</div>
								</div>
								<div className="flex mt-10">
									<label htmlFor="rangeDate" className="control-label left col-3">Thời gian dãn cách</label>
									<div className="flex gap-20 item-flex-start w-100">
										<input id="rangeDate" type="number" className="form-control w-20 price-input" min={1} value={rangeDate} onChange={(e) => {
											setRangeDate(e.target.value)
										}} />
									</div>
								</div>
								{/* <div className="flex mt-10">
									<label htmlFor="countVoucherUse" className="control-label col-3">Tặng voucher gội đầu</label>
									<div className="flex gap-20 item-flex-start w-100">
										<input id="countVoucherUse" onChange={(e) => {setCountVoucherUse(e.target.value)}} className="form-control w-20 price-input" defaultValue={0} placeholder="127" />
										<span className="input-group-addon">( Config số lần sử dụng )</span>
									</div>
								</div> */}
								<div className="flex mt-10">
									<label htmlFor="productId" className="control-label left col-3">Buổi lẻ</label>
									<div className="row gap-20 item-flex-start w-100">
										<div className="col-12">
											<Select components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }} 
												className="basic-single w-100"
												classNamePrefix="select"
												closeMenuOnSelect={true}
												isClearable={true}
												isSearchable={true}
												onChange={setProductId}
												options={products}
											/>
										</div>
									</div>
								</div>
								<div className="flex mt-10">
									<label htmlFor="giftProduct" className="control-label left col-3">Buổi tặng</label>
									<div className="row gap-20 item-flex-start w-100">
										<div className="col-12">
											<Select components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }} 
												className="basic-single w-100"
												classNamePrefix="select"
												closeMenuOnSelect={false}
												isClearable={true}
												isSearchable={true}
												isMulti
												onChange={onSelectGiftPackage}
												options={products}
											/>
										</div>
									</div>
								</div>
								<div className="flex mt-10">
									<label htmlFor="category" className="control-label left col-3">Nhóm dịch vụ</label>
									<div className="row gap-20 item-flex-start w-100">
										<div className="col-12">
											{listSelectGroup.length > 0 ?
												<Select components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }} 
													className="basic-single w-100"
													classNamePrefix="select"
													closeMenuOnSelect={false}
													isClearable={true}
													isSearchable={true}
													closeMenuOnSelect={true}
													onChange={onSelectCategory}
													options={listSelectGroup}
												/>
											:null}
										</div>
									</div>
								</div>
								{categoryId == 5 ? 
									<>
										<div className="flex mt-10">
											<label className="control-label left col-3">Thông tin bảo hành</label>
											<div className="row">
												<div className="col-xs-12 col-md-4">
													<label className="control-label">Số buổi</label>
													<input onChange={(e) => setWarranty(e.target.value)} className="form-control w-100 price-input" defaultValue={0} />
												</div>
												<div className="col-xs-12 col-md-4">
													<label className="control-label">Thời gian</label>
													<input onChange={(e) => setWarrantyExpiry(e.target.value)} className="form-control w-100 price-input" defaultValue={warrantyExpiry} />
													<span className="input-group-addon">(Đơn vị: Tháng)</span>
												</div>
												<div className="col-xs-12 col-md-4">
													<label className="control-label">Ngày dãn cách</label>
													<input onChange={(e) => setRangeWarranty(e.target.value)} className="form-control w-100 price-input" defaultValue={rangeWarranty} />
													<span className="input-group-addon">(Đơn vị: Ngày)</span>
												</div>
											</div>
										</div>
										<div className="flex mt-10">
											<label className="control-label col-3">Loại thẻ triệt</label>
											<div className="row gap-20 item-flex-start w-100 ">
												<div className="col-12">
													{optionWaxing.length > 0 ?
														<Select components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }} 
															className="basic-single w-100"
															classNamePrefix="select"
															closeMenuOnSelect={false}
															isClearable={true}
															isSearchable={true}
															closeMenuOnSelect={true}
															onChange={setNewWaxing}
															options={optionWaxing}
														/>
													:null}
												</div>
											</div>
										</div>
									</>
								: null}

								<div className="flex mt-10">
									<label className="control-label left col-3">Nhóm dịch vụ nâng cấp</label>
									<div className="flex gap-20 item-flex-start w-100 ">
										<Select components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }} 
											className="basic-single w-100"
											classNamePrefix="select"
											closeMenuOnSelect={false}
											isClearable={true}
											defaultValue={defaultValueUpgrade}
											isSearchable={true}
											isMulti
											onChange={onSelectUpgrade}
											options={products}
										/>
									</div>
								</div>
								<div className="flex mt-10">
									<label className="control-label left col-3">Thẻ con</label>
									<div className="flex gap-20 item-flex-start w-100 ">
										<Select components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }} 
											className="basic-single w-100"
											classNamePrefix="select"
											closeMenuOnSelect={false}
											isClearable={true}
											defaultValue={defaultProductUsingId}
											isSearchable={true}
											isMulti
											onChange={onSelectProductUsingIds}
											options={products}
										/>
									</div>
								</div>
								{productUsingIds.length > 0 ?
									<>
										<div className="flex mt-10">
											<label className="control-label left col-3">Kiểu sử dụng</label>
											<div className="flex align-center">
												<Checkbox onChange={() => {setTypeUsing(!typeUsing)}}>Sử dụng tính theo lần dịch vụ con</Checkbox>
											</div>
										</div>
										<div className="flex mt-10">
											<label className="control-label left col-3">Số lần sử dụng của thẻ con</label>
											<div className="flex align-center">
												<Checkbox checked={maxUseChild} onChange={() => setMaxUseChild(!maxUseChild)}>Số lần sử dụng của thẻ con tính theo thẻ cha</Checkbox>
											</div>
										</div>
									</>
								: null}
								<div className="form-item-wrapper">
									<div className="flex mt-10">
										<label className="control-label left col-3">Com phục vụ</label>
										<div className=' gap-20 item-flex-start w-100'>
											<div className="row">
												<div className="col-6">
													<input onChange={(e) => {setComServe(e.target.value)}} className="form-control w-20 price-input" defaultValue={0} />
												</div>
												<div className="col-6">
													<Checkbox checked={specialService} onChange={() => setSpecialService(!specialService)}>Dịch vụ đặc biệt</Checkbox>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</form>
					</div>
					<div className="bottom-popup">
						<div className="button-container">
							<div className="column-left">
								<Checkbox checked={typeSell} onChange={() => setTypeSell(!typeSell)}>Mở bán ?</Checkbox>
							</div>
							<div className="column-right">
								<div className="button-cent style3" onClick={() => setOpen(!open)}>
									<span><i className="fa-solid fa-x"></i></span>Đóng
								</div>
								<div className="button-cent" onClick={() => addNewPackage()}>
									<span><i className="fa-solid fa-file-lines"></i></span>Lưu thông tin
								</div>
							</div>

						</div>
					</div>
				</div>
				<div className="overlay" onClick={() => setOpen(!open)}></div>
			</div>
		);
	} else return <div></div>;
}

export default ModalCreateCard